import auth from './auth.json';
import actions from './actions.json';
import verification from './verification.json';
import pin from './pin.json';
import product from './product.json';

import cards from './cards.json';
import sliders from './sliders.json';
import screens from './screens.json';
import faqs from './faqs.json';

import accounts from './accounts.json';
import onboarding from './onboarding.json';

import design from './design.json';
import profile from './profile.json';
import themes from './themes.json';
import colors from './colors.json';
import settings from './settings.json';
import checkout from './checkout.json';
import menu from './menu.json';

const configs = {
  accounts,
  profile,
  sliders,
  auth,
  actions,
  verification,
  pin,
  product,
  cards,
  screens,
  faqs,
  onboarding,
  design,
  themes,
  colors,
  settings,
  checkout,
  menu,
};

export default configs;
